'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuItemStyled = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MenuItemStyled = exports.MenuItemStyled = _styledComponents2.default.li.withConfig({
  displayName: 'MenuItemStyled'
})(['display:flex;flex-direction:column;padding:0;align-items:stretch;position:relative;user-select:none;&:focus{outline:none}']);

MenuItemStyled.displayName = 'MenuItemStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-menu/dist/MenuItem/styles/MenuItemStyled.js
// module id = 746
// module chunks = 0